'use strict';

var $ = require('jquery');
var basePage = require('../pages/base-page.js');
var fullScreenGallery = require('../components/full-screen-gallery.js');
var affiliateLinks = require('../utils/affiliate-links.js');

basePage.init = function() {
	basePage.initBasePage();

	var $context = $('#vanReviewDimensionsPage');
	fullScreenGallery.init($context);
	
	affiliateLinks.appendTrackingToAmazonLinks();
};

module.exports = basePage;